import { Request } from '~src/httpClient/serverApi/requests/Request';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';

import { IPrivateConnectionInfo } from '../../models/PrivateConnectModels';

export interface IGetPrivateConnectionsParams {}

export interface IGetPrivateConnectionsResult extends IResult {
  privateConnections?: IPrivateConnectionInfo[];
}

export class GetPrivateConnectionsRequest extends Request<IGetPrivateConnectionsParams, IGetPrivateConnectionsResult> {
  constructor(params: IGetPrivateConnectionsParams) {
    super('getPrivateConnections', params);
  }
}